import React from "react";
import { HERO_IMAGE, HERO_AVATARS, HERO_FEATURES } from "../data/data";
import locationIcon from "../../img/locate location map pin.png";
import countriesIcon from "../../img/Countries.png";
 
export default function HeroSection() {
  return (
    <section
      className="relative w-full overflow-hidden min-h-screen sm:h-screen flex flex-col justify-between gap-8 pt-8 pb-6 px-5 sm:pt-12 sm:pb-14 sm:px-12 font-sans select-none"
      style={{
        backgroundImage: `url(${HERO_IMAGE})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ── Top Bar / Header Content ── */}
      {/* Mobile: sab kuch center me, upar-neeche. Desktop (sm+): left headline + right badge */}
      <div className="flex flex-col items-center sm:flex-row sm:justify-between sm:items-start gap-6 sm:gap-0 w-full relative z-10">
       
        {/* Main Headline */}
        <div className="max-w-xl text-white text-center sm:text-left">
          <h1 className="text-4xl sm:text-6xl leading-none font-semibold tracking-tight drop-shadow-md">
            Find Your Next
          </h1>
          <p
            className="text-5xl sm:text-7xl leading-none -mt-1 mb-0 drop-shadow-lg"
            style={{
              fontFamily: "'Dancing Script', 'Caveat', cursive",
              fontWeight: 700,
            }}
          >
            Adventure
          </p>
          <p
            spellCheck={false}
            className="mt-2 text-sm sm:text-base font-normal text-white/90 max-w-sm mx-auto sm:mx-0 leading-relaxed drop-shadow"
          >
            Discover breathtaking places, connect with likeminded travelers, and create unforgettable memories together.
          </p>
        </div>
 
        {/* Glass Badge (mobile me headline ke neeche center me, desktop me top right) */}
        <div className="flex flex-col items-center text-center sm:items-start sm:text-left gap-2 rounded-2xl bg-black/40 backdrop-blur-md border border-white/10 p-4 text-white shadow-2xl w-full max-w-[260px] sm:max-w-none sm:w-auto sm:min-w-[260px]">
          <div className="flex items-center justify-center sm:justify-start gap-2">
            <div className="flex items-center -space-x-2">
              {HERO_AVATARS.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Traveler ${i + 1}`}
                  className="h-9 w-9 rounded-full border-2 border-slate-800 object-cover"
                />
              ))}
            </div>
            <span className="text-sm font-semibold text-white/90">+57</span>
          </div>
          <div className="mt-1 leading-tight">
            <p className="text-xs font-bold tracking-wide">1,400+ Travelers</p>
            <p className="text-[11px] text-white/70">already exploring together</p>
          </div>
        </div>
 
      </div>
 
      {/* ── Bottom Section: Glass Features + White Stats Card ── */}
      <div className="relative z-10 flex flex-col lg:flex-row gap-4 items-stretch w-full lg:mt-6">
 
        {/* Feature Pills Container (mobile: upar-neeche list, left aligned) */}
        <div className="flex-1 rounded-2xl bg-teal-950/40 backdrop-blur-md border border-white/20 px-5 py-5 sm:px-6 sm:py-6 flex flex-col items-start gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-around sm:gap-y-4 lg:flex-nowrap shadow-xl">
          {HERO_FEATURES.map(({ iconSrc, title, subtitle }, index) => (
            <React.Fragment key={title}>
              <div className="flex items-center gap-3 sm:px-2">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-lg shrink-0">
                  <img
                    src={iconSrc}
                    alt={title}
                    className="h-5 w-5 shrink-0 object-contain"
                  />
                </div>
                <div className="leading-tight">
                  <p className="text-sm sm:text-xs font-bold text-white tracking-wide whitespace-nowrap">{title.replace(/\s+/g, " ").trim()}</p>
                  <p className="text-xs sm:text-[11px] text-white/70 mt-0.5 whitespace-nowrap">{subtitle.replace(/\s+/g, " ").trim()}</p>
                </div>
              </div>
              {index !== HERO_FEATURES.length - 1 && (
                <div className="hidden lg:block w-px h-8 bg-white/20 shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>
 
        {/* Stats Card (mobile: full width, neeche) */}
        <div className="rounded-2xl bg-white px-6 sm:px-8 py-5 flex items-start justify-around sm:justify-center gap-6 sm:gap-10 shadow-2xl shrink-0">
          {/* Destination Stat */}
          <div className="flex items-start gap-3">
            <img
              src={locationIcon}
              alt="Destinations"
              className="h-5 w-5 shrink-0 object-contain mt-0.5"
            />
            <div className="leading-tight">
              <p className="text-base font-extrabold text-slate-900">1400+</p>
              <p className="text-xs font-medium text-slate-500 mt-1">Destinations</p>
            </div>
          </div>
 
          {/* Countries Stat */}
          <div className="flex items-start gap-3">
            <img
              src={countriesIcon}
              alt="Countries"
              className="h-5 w-5 shrink-0 object-contain mt-0.5"
            />
            <div className="leading-tight">
              <p className="text-base font-extrabold text-slate-900">120+</p>
              <p className="text-xs font-medium text-slate-500 mt-1">Countries</p>
            </div>
          </div>
        </div>
 
      </div>
    </section>
  );
}